import { createFileRoute, notFound } from "@tanstack/react-router";
import { HijriMonthPage } from "@/components/pages/HijriMonthPage";
import { HIJRI_MONTHS_EN } from "@/lib/calendar/hijri";

export const Route = createFileRoute("/en/hijri-calendar/$hyear/$hmonth/")({
  beforeLoad: ({ params }) => {
    if (params.hyear.startsWith("$") || params.hmonth.startsWith("$")) {
      throw notFound();
    }
  },
  loader: ({ params }) => {
    const hYear = parseInt(params.hyear, 10);
    const hMonth = parseInt(params.hmonth, 10);
    if (!Number.isFinite(hYear) || hYear < 1300 || hYear > 1600) throw notFound();
    if (!Number.isFinite(hMonth) || hMonth < 1 || hMonth > 12) throw notFound();
    return { hYear, hMonth };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { hYear, hMonth } = loaderData;
    const monthName = HIJRI_MONTHS_EN[hMonth - 1];
    const title = `${monthName} ${hYear} AH - Hijri & Gregorian Calendar`;
    const desc = `Islamic (Hijri) calendar ${monthName} ${hYear} AH with Gregorian conversion, Islamic events, and Indonesian public holidays.`;
    const enUrl = `https://hari.co.id/en/hijri-calendar/${hYear}/${hMonth}/`;
    const idUrl = `https://hari.co.id/kalender-hijriah/${hYear}/${hMonth}/`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: enUrl },
        { property: "og:locale", content: "en_US" },
        { property: "og:locale:alternate", content: "id_ID" },
      ],
      links: [{ rel: "canonical", href: enUrl }],
    };
  },
  component: () => {
    const { hYear, hMonth } = Route.useLoaderData();
    return <HijriMonthPage hYear={hYear} hMonth={hMonth} locale="en" />;
  },
  notFoundComponent: () => <div className="p-8 text-center">Invalid Hijri month.</div>,
  errorComponent: ({ error }) => <div className="p-8 text-center">Error: {error.message}</div>,
});